import ActivatePage from "@/pages/ActivatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/activate")({
  component: ActivatePage,
});
